export enum Role {
  Admin = 0,
  Employee,
  Parent,
  Student,
  Candidate,
}
